import { getData } from "@/utils/fetch";
import debounce from "debounce-promise";
import { defineStore } from "pinia";

let debouncedFetch = debounce(getData, 500);

export const useSgnTotalStore = defineStore({
  id: "sgnTotal",
  state: () => ({
    sgnTotal: {},
    sgnTotalDetail: {},
  }),
  getters: {
    getData(state) {
      return state.sgnTotal.data;
    },
  },
  actions: {
    async getTotal() {
      this.sgnTotal = { loading: true };
      try {
        const result = await debouncedFetch("sgn_total");
        this.sgnTotal = { ...result.data };
      } catch (error) {
        console.log(error);
        this.sgnTotal = { error };
      }
    },
    async getDetail(params) {
      this.sgnTotalDetail = { loading: true };
      const dataparams = {
        limit: params?.limit || 50,
        offset: params?.offset || 0,
      };
      try {
        const res = await debouncedFetch("sgn_total/detail", dataparams);
        this.sgnTotalDetail = { ...res.data };
      } catch (error) {
        console.log(error);
        this.sgnTotalDetail = { error };
      }
    },
  },
});
